import { useState, useEffect } from "react";

export function useSessionStorage<T>(key: string, initialValue: T) {
    // 从 sessionStorage 获取存储的值，如果没有则使用初始值
    const getStoredValue = () => {
        const storedValue = sessionStorage.getItem(key);
        if (storedValue) {
            try {
                return JSON.parse(storedValue);
            } catch (error) {
                console.error(error);
                return null;
            }
        }
        return initialValue;
    };

    const [value, setValue] = useState<T>(getStoredValue);

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(error);
        }
    }, [key, value]);

    return [value, setValue] as const;
}

export function useLocalStorage<T>(key: string, initialValue: T) {
    // 从 localStorage 获取存储的值，如果没有则使用初始值
    const getStoredValue = () => {
        const storedValue = localStorage.getItem(key);
        if (storedValue) {
            try {
                return JSON.parse(storedValue);
            } catch (error) {
                console.error(error);
                return null;
            }
        }
        return initialValue;
    };

    const [value, setValue] = useState<T>(getStoredValue);

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(error);
        }
    }, [key, value]);

    return [value, setValue] as const;
}
